import React from 'react';
import { Drawer as AntdDrawer, DrawerProps as AntdDrawerProps } from 'antd';

interface Props extends AntdDrawerProps {}

const Drawer: React.FC<Props> = (props: Props) => {
	return <AntdDrawer {...props} />;
};

export default Drawer;
